'use strict';

const $ = require('jquery');
const util = require('../utils/util');
const minicart = require('../components/header/minicart');
const cartoverlay = require('../components/checkout/cartoverlay');
const createAccountSlider = require('./account/components/accountslider').createAccountSlider;
const einsteinCarousel = require('../components/sliders/einstein-carousel').einsteinCarousel;
const membersOnlyFlyin = require('../flyins/membersonlyflyin');
const quickShopWishlist = require('../components/product/quickShopWishlist');
const gtmTracking = require('../components/tracking/tracking');
const addToCartActions = require('../pages/product/addToCart');
const commonModules = require('../components/common');

var updateWishlist = function (showConfirmation) {
    const $wishlistpage = $('#wishlistpage');
    const wishlistUrl = $wishlistpage.data('main');
    $.ajax({
        url: wishlistUrl,
        type: 'POST',
        data: {
            showConfirmation
        }
    }).done(function (res) {
        $wishlistpage.html(res);
    });
};

var updateMiniWishlist = function () {
    const $wishlistpage = $('#wishlistpage');
    const $miniWishlistContainer = $('li.nav-item-wishlist');
    let $mobileQty;
    const miniWishlistUrl = $wishlistpage.data('mini');
    let qty = 0;
    $.ajax({
        url: miniWishlistUrl,
        type: 'POST'
    }).done(function (res) {
        $miniWishlistContainer.html(res);
        // change quantity for mobile header
        qty = $('.mini-whishlist-total .mini-wishlist-quantity').html();
        if (qty) {
            $mobileQty = $('.header-mobile-wishlist .qty');
            if ($mobileQty.length === 0) {
                $('.header-mobile-wishlist').append('<span class="qty"></span>');
            }
            $('.header-mobile-wishlist .qty').html(qty);
        } else if ($('.header-mobile-wishlist .qty')) {
            $('.header-mobile-wishlist .qty').remove();
        }
        $('html, body').animate({scrollTop: 0});
    });
};

var updateMiniCart = function (response, showOverlay) {
    const splitted = response.split(util.contentSplitter);
    let options = {};
    try {
        options = JSON.parse(splitted[1]);
    } catch (err) {
        // nothing to do, default value is {}
    }
    if (showOverlay) {
        cartoverlay.show(splitted[2]);
    }
    minicart.update(splitted[0], options);
};

var addToCart = function (e) {
    const $this = $(this);
    const $form = $this.closest('form');
    const $row = $this.parents('tr');
    const isVariationGroup = $form.data('isVariationGroup');

    e.preventDefault();

    if (
        $this.hasClass('member-shop') ||
        $this.hasClass('pre-order-button') ||
        $this.hasClass('member-exclusives') ||
        $this.hasClass('sign-in-to-buy')
    ) {
        membersOnlyFlyin.init(e.target);
        return;
    }

    if (isVariationGroup) {
        const pid = $form.find('input[name="pid"]').val();
        quickShopWishlist.init(pid);
        return;
    }

    addToCartActions.addItemToCart($form).then(function (response) {
        if (!response.success && response.error) {
            return addToCartActions.handleAddToCartResponseError();
        }
        updateMiniCart(response, true);
        updateWishlist();
        updateMiniWishlist();
        $row.remove();
    });
};

var addAllToCart = function (e) {
    const $form = $(this).closest('form');
    const productsData = $form.serializeArray();
    const wishlistProductsIds = productsData.find(item => item.name === 'childPids').value;
    const wishlistProductsQtys = productsData.find(item => item.name === 'qtys').value;

    e.preventDefault();
    $.ajax({
        url: util.appendParamToURL($form.attr('action'), 'format', 'ajax'),
        type: 'POST',
        data: $form.serialize()
    }).done(function (res) {
        updateMiniCart(res, false);
        updateWishlist(true);
        updateMiniWishlist();

        let getTrackingDataUrl = $('.js-add-all-wrapper').data('get-tracking-url');
        gtmTracking.trackProductSetAddToCart(wishlistProductsQtys, wishlistProductsIds, getTrackingDataUrl);
    });
};

var remove = function (e) {
    const $form = $(this).closest('form');
    const $wishlistpage = $('#wishlistpage');

    e.preventDefault();
    // update the main wishlist part
    $.ajax({
        url: $form.attr('action'),
        type: 'POST',
        data: $form.serialize()
    }).done(function (res) {
        $wishlistpage.html(res);
        updateMiniWishlist();
    });
};

function initializeEvents() {
    $('.pt_account').on('click', '.wishlist-add-to-cart', addToCart);
    $('.pt_account').on('click', '.button-cart-all', addAllToCart);
    $('.pt_account').on('click', '.button-remove-all', remove);
    $('.pt_account').on('click', '.button-remove', remove);
}

const initWishlistSlider = () => {
    const $productsContainer = $('.pt_account .account-slider .product-slider-container').not('.slick-initialized');
    createAccountSlider($productsContainer, {
        autoplay: false,
        dots: false
    });
};

exports.init = function () {
    if (navigator.userAgent.indexOf('Mac') !== -1) {
        $('html').addClass('mac-os');
    }

    const isWishlist = $('#wishlistpage').length > 0;
    const isMacOs = $('html').hasClass('mac-os');

    if (isWishlist && isMacOs) {
        commonModules.initializeDom();
    }

    initializeEvents();
    initWishlistSlider();
    einsteinCarousel(initWishlistSlider);

    if (sessionStorage.getItem('signInToBuyLogin') === 'true' && sessionStorage.getItem('signInToBuyProduct') != '') {
        var pid = sessionStorage.getItem('signInToBuyProduct');
        var wishList = $('.wish-list-container');
        sessionStorage.removeItem('signInToBuyLogin');
        sessionStorage.removeItem('signInToBuyProduct');

        if (wishList.length > 0 && wishList.find('input[value="' + pid + '"]').length > 0) {
            var pliContainer = wishList.find("input[value='" + pid + "']").parent();

            if (pliContainer.find('.wishlist-add-to-cart').length > 0) {
                pliContainer.find('.wishlist-add-to-cart').eq(0).click();
            }
        }
    }

    // if the user just created their account - send an event to dataLayer
    if (sessionStorage.getItem('regSource') && sessionStorage.getItem('regSource') != '') {
        if (window.dataLayer) {
            window.dataLayer.push({
                event: 'myAccountSignup',
                myAccountSignupStep: sessionStorage.getItem('regSource')
            });
        }
        sessionStorage.removeItem('regSource');
    }
};
